<template>
  <v-col cols="2">
    <v-text-field v-model="channelPercent" :label="title" @input="updateValue" prefix="%"></v-text-field>
    <v-slider
      v-model="channelPercent"
      step="1"
      style="margin-top: -20px;"
      @input="updateValue"
    ></v-slider>
  </v-col>
</template>

<script>
export default {
  data () {
    return {
      channelPercent: this.value
    }
  },
  methods: {
    updateValue () {
      this.$emit('input', {
        key: this.channelName,
        value: Number(this.channelPercent)
      })
    }
  },
  computed: {
    title: function () {
      return `${this.channelName} (${this.standardValue}%)`
    }
  },
  props: {
    channelName: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    standardValue: {
      type: Number,
      required: true
    }
  },
  created () {
    this.updateValue()
  },
  watch: {
    'value': function () {
      this.channelPercent = this.value
      this.updateValue()
    }
  }
}
</script>
